export default __webpack_public_path__ + "static/media/loginBg.1997aab0.png";